import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    
    obterTodos() {
        let url = `${api}/contratos/fiscalizacoes`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterContratos() {
        let url = `${api}/contratos/fiscalizacoes/contratos-vigentes`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProcessos() {
        let url = `${api}/contratos/fiscalizacoes/processos-fiscalizacao`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFiscalizacao(fiscalizacaoId) {
        let url = `${api}/contratos/fiscalizacoes/${fiscalizacaoId}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirFiscalizacao(fiscalizacao) {
        return axiosJwt
            .post(`${api}/contratos/fiscalizacoes`, fiscalizacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarFiscalizacao(fiscalizacao) {
        return axiosJwt
            .put(`${api}/contratos/fiscalizacoes/${fiscalizacao.idFiscalizacao}`, fiscalizacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarIrregularidadeFiscalizacao(idFiscalizacao, idIrregularidade) {        
        return axiosJwt
            .delete(`${api}/contratos/fiscalizacoes/${idFiscalizacao}/desassociar-irregularidade/${idIrregularidade}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterIrregularidadesDisponiveis(idFiscalizacao) {
        let url = `${api}/contratos/fiscalizacoes/${idFiscalizacao}/irregularidades-disponiveis`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDadosIrregularidade(idIrregularidade) {
        let url = `${api}/contratos/irregularidades/${idIrregularidade}`
        return axiosJwt
           .get(url)
           .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarIrregularidade(idFiscalizacao, idIrregularidade, diasParaCorrecao) {
        let url = `${api}/contratos/fiscalizacoes/${idFiscalizacao}/associar-irregularidade/${idIrregularidade}`
        return axiosJwt
            .put(url, {
                diasParaCorrecao: diasParaCorrecao
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterarDiasParaCorrecaoIrregularidade(idIrregularidadeFiscalizacao, novosDias) {
        let url = `${api}/contratos/irregularidades-fiscalizacao/${idIrregularidadeFiscalizacao}/alterar-dias`
        return axiosJwt
            .put(url, {
                novosDias: novosDias
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })        
    },

    obterIrregularidadeFiscalizacao(idIrregularidadeFiscalizacao) {
        let url = `${api}/contratos/irregularidades-fiscalizacao/${idIrregularidadeFiscalizacao}`
        return axiosJwt
        .get(url)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorHandler(error)
        })
    },

    avaliarIrregulridadeFiscalizacao(idIrregularidadeFiscalizacao, avaliacaoIrregularidadeFiscalizacao) {
        let url = `${api}/contratos/irregularidades-fiscalizacao/${idIrregularidadeFiscalizacao}/avaliar`

        const formData = new FormData();
        formData.append('conformidade', avaliacaoIrregularidadeFiscalizacao.conformidade);
        formData.append('descricao', avaliacaoIrregularidadeFiscalizacao.descricao);

        if (avaliacaoIrregularidadeFiscalizacao.anexos && avaliacaoIrregularidadeFiscalizacao.anexos.length > 0) {
            avaliacaoIrregularidadeFiscalizacao.anexos.forEach((arquivo) => {
                formData.append('anexos', arquivo);
            });
        }

        return axiosJwt
        .post(url, formData)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return errorHandler(error);
        });
    },

    // alterar quando for testar com os arquivos
    downloadAvaliacaoAnexo(documento) {
        let url = `${api}/contratos/avaliacoes-irreguralidade/${documento.idDocumentoAvaliacaoIrregularidade}/download-avaliacao`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAvaliacaoIrregularidadeFiscalizacao(idAvaliacaoIrregularidade) {
        let url = `${api}/contratos/avaliacoes-irreguralidade/${idAvaliacaoIrregularidade}`
        return axiosJwt
        .get(url)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorHandler(error)
        })
    }
}
